<template>
  <div>
    <div>
      <div class="item">
        <span class="title">消耗时间</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          class="hide-close-button"
          end-placeholder="结束日期"
          @change="handleConsumptionDateChange"
        />
      </div>
      <div class="item">
        <span class="title">新用户充值时间</span>
        <el-date-picker
          v-model="dates"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <div class="item">
        <span class="title">主渠道号</span>
        <el-autocomplete
          v-model="parameterNames.master_appid_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          style="width: 350px"
          :clearable="true"
          @clear="
            ;(parameterNames.master_appid_name = null),
              (parameter.master_appid = null)
          "
          @focus="current = '主渠道号'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">副渠道号</span>
        <el-autocomplete
          v-model="subChannelName"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          style="width: 350px"
          :clearable="true"
          @clear="subChannelName = null"
          @focus="current = '副渠道号'"
          @select="handleSelect"
        />
      </div>
      <div class="checkBox">
        <span class="checkBox_title">选中的渠道号</span>
        <div class="checkBox_content">
          <el-tag
            v-for="item in officialObj"
            :key="item.value"
            class="content_item"
            style="margin: 5px;"
            size="small"
          >
            {{ item.label || item.value }}
            <i
              class="el-icon-close"
              style="font-size: 18px;"
              @click="deleteOfficialAccount(item)"
            /></el-tag>
        </div>

      </div>
      <div class="item">
        <span class="title">投放组</span>
        <el-autocomplete
          v-model="parameterNames.release_group_id_name"
          :fetch-suggestions="querySearchAsync"
          :clearable="true"
          placeholder="请输入内容"
          @clear="
            ;(parameterNames.release_group_id_name = null),
              (parameter.release_group_id = null)
          "
          @focus="current = '投放组'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">投手</span>
        <el-autocomplete
          v-model="parameterNames.pitcher_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="
            ;(parameterNames.pitcher_id_name = null),
              (parameter.pitcher_id = null)
          "
          @focus="current = '投手'"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="title">书籍归属</span>
        <el-autocomplete
          v-model="parameterNames.book_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="
            ;(parameterNames.book_id_name = null), (parameter.book_id = null)
          "
          @focus="current = '书籍归属'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">书名</span>
        <el-autocomplete
          v-model="parameterNames.alias_book_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="
            ;(parameterNames.alias_book_id_name = null),
              (parameter.alias_book_id = null)
          "
          @focus="current = '书名'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">投放位置</span>
        <el-autocomplete
          v-model="parameterNames.position_id_name"
          :fetch-suggestions="querySearchAsync"
          :clearable="true"
          placeholder="请输入内容"
          @clear="
            ;(parameterNames.position_id_name = null),
              (parameter.position_id = null)
          "
          @focus="current = '投放位置'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">ADQ广告主</span>
        <div>
          <el-input
            v-model="multipleSub1"
            style="width: 150px"
            placeholder="请输入多个的名字"
            @input="handleParams1($event, 1)"
          />
          <el-button
            type="primary"
            style="margin-left: 10px"
            :disabled="date.length === 0"
            @click="multipleSubOfficialAccount1(1)"
          >选中多个</el-button>
        </div>
      </div>
      <div class="checkBox">
        <span class="checkBox_title">选中的ADQ广告主</span>
        <div
          v-if="advertiserObjUnique.length"
          ref="adqVirtualScroller"
          class="virtual-tag-scroller"
          :style="{ maxHeight: virtualTagViewport + 'px' }"
          @scroll="onVirtualScroll('adqVirtualScroller', 'adqScrollTop')"
        >
          <div
            class="virtual-tag-phantom"
            :style="{ height: adqVirtualView.totalHeight + 'px' }"
          >
            <div
              v-for="row in adqVirtualView.items"
              :key="row.key"
              class="virtual-tag-row"
              :style="{
                height: virtualTagItemHeight + 'px',
                transform: 'translateY(' + row.top + 'px)'
              }"
            >
              <el-tag
                class="content_item virtual-tag"
                :title="row.item.label"
                size="small"
                @click="advertiserObjtag(row.index, 'adq', row.item)"
              >
                <span class="virtual-tag-label">{{ row.item.label }}</span>
                <i
                  class="el-icon-close"
                  style="font-size: 18px"
                  @click.stop="deleteOfficialAccount1(row.item, 1)"
                />
              </el-tag>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <span class="title">巨量广告</span>
        <div>
          <el-input
            v-model="multipleSub2"
            style="width: 150px"
            placeholder="请输入多个的名字"
            @input="handleParams1($event, 2)"
          />
          <el-button
            type="primary"
            style="margin-left: 10px"
            :disabled="date.length === 0"
            @click="multipleSubOfficialAccount1(2)"
          >选中多个</el-button>
        </div>
      </div>
      <div class="checkBox">
        <span class="checkBox_title">选中的巨量广告</span>
        <div
          v-if="advertiserObj1Unique.length"
          ref="oceanVirtualScroller"
          class="virtual-tag-scroller"
          :style="{ maxHeight: virtualTagViewport + 'px' }"
          @scroll="onVirtualScroll('oceanVirtualScroller', 'oceanScrollTop')"
        >
          <div
            class="virtual-tag-phantom"
            :style="{ height: oceanVirtualView.totalHeight + 'px' }"
          >
            <div
              v-for="row in oceanVirtualView.items"
              :key="row.key"
              class="virtual-tag-row"
              :style="{
                height: virtualTagItemHeight + 'px',
                transform: 'translateY(' + row.top + 'px)'
              }"
            >
              <el-tag
                class="content_item virtual-tag"
                :title="row.item.label"
                size="small"
                @click="advertiserObjtag(row.index, 'ad', row.item)"
              >
                <span class="virtual-tag-label">{{ row.item.label }}</span>
                <i
                  class="el-icon-close"
                  style="font-size: 18px"
                  @click.stop="deleteOfficialAccount1(row.item, 2)"
                />
              </el-tag>
            </div>
          </div>
        </div>
      </div>

      <div class="item">
        <span class="title">平台id</span>
        <el-select
          v-model="parameter.platform_id"
          style="margin-right: 20px"
          placeholder="请选择平台"
          filterable
          :clearable="true"
          @clear="parameter.platform_id = null"
        >
          <el-option
            v-for="(item, index) in platformSelectList"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>
    </div>

    <div style="text-align: end; margin-top: 20px">
      <el-button class="" type="primary" @click="determine">确定</el-button>
    </div>
    <el-dialog
      title="时间选择"
      :close-on-click-modal="false"
      :visible.sync="dialogDate"
      width="500px"
      append-to-body
    >
      <el-button
        style="float: right; margin-bottom: 5px"
        type="success"
        icon="el-icon-plus"
        circle
        @click="copy"
      />

      <div
        v-for="row in advertiserSecondaryMatched"
        :key="`${ADtype}-${row.item.value}-${row.index}`"
        class="checkBox_content"
      >
        <el-date-picker
          :key="`${ADtype}-${row.item.value}-${row.index}-${(row.item.date || []).join('_')}`"
          v-model="row.item.date"
          :picker-options="expireTimeOption"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          class="hide-close-button"
          end-placeholder="结束日期"
          style="margin-top: 5px"
          @change="handleAdvertiserDateChange(row.item, $event)"
        />
        <el-button
          type="danger"
          icon="el-icon-delete"
          circle
          @click="deleteitem(row.index, row.item)"
        />
      </div>
      <el-button
        style="margin-left: 300px; margin-top: 40px"
        type="primary"
        @click="subimt"
      >确定</el-button>
    </el-dialog>
  </div>
</template>

<script>
import {
  getReleaseGroupListNovel,
  getListOfPitchersInTheLaunchGroupNovel,
  getTitleListNovel,
  getBookOwnershipListNovel,
  dropLocationListNovel,
  getAdvertiserNovel,
  getPlatform,
  getTheListOfOfficialAccountNovelSite
} from '@/api/newLaunchGroup.js'
export default {
  props: {
    drawerItem: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      parameter: {
        master_appid: null, // 主渠道号
        release_group_id: null, // 投放组
        pitcher_id: null, // 投手
        alias_book_id: null, // 书名
        book_id: null, // 书籍归属
        position_id: null, // 投放位置
        platform_id: null // 平台
      },
      parameterNames: {
        master_appid_name: null, // 主渠道号
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        alias_book_id_name: null, // 书名
        book_id_name: null, // 书籍归属
        position_id_name: null, // 投放位置
        app_id_name: null // 平台
      },
      current: null,
      loading: false,
      loading1: false,
      date: [],
      dates: [],
      officialValue: [], // 副渠道号值
      fromOfficialAccount: [], // 从渠道号
      subChannelName: null, // 副渠道号搜索输入
      officialObj: [], // 辅助渲染的渠道号
      platformSelectList: [],
      advertiserValue: [], // 广告主值
      advertiserValue1: [], // 巨量广告主值
      fromAdvertiser: [], // 广告主
      fromAdvertiser1: [], // 巨量广告
      advertiserObj: [], // 辅助广告主渲染
      advertiserObj1: [], // 辅助巨量广告渲染
      multipleSub: null, // 输入的多个从渠道号的名字
      multipleSub1: null, // 输入的多个广告主的名字
      multipleSub2: null, // 输入的多个巨量广告的名字
      index: '',
      dialogDate: false,
      ADtype: '',
      aditem: {},
      advertiserSecondary: [],
      advertiserSecondary1: [],
      adqScrollTop: 0,
      oceanScrollTop: 0,
      virtualTagItemHeight: 34,
      virtualTagViewport: 280
    }
  },
  computed: {
    advertiserObjUnique() {
      return this.buildUniqueAdvertiserRows(this.advertiserObj)
    },
    advertiserObj1Unique() {
      return this.buildUniqueAdvertiserRows(this.advertiserObj1)
    },
    adqVirtualView() {
      return this.buildVirtualView(this.advertiserObjUnique, this.adqScrollTop)
    },
    oceanVirtualView() {
      return this.buildVirtualView(this.advertiserObj1Unique, this.oceanScrollTop)
    },
    advertiserSecondaryMatched() {
      const source =
        this.ADtype === 'adq'
          ? this.advertiserSecondary
          : this.advertiserSecondary1
      const value = this.aditem && this.aditem.value
      const rows = []
      if (!source || value == null || value === '') return rows
      for (let i = 0; i < source.length; i++) {
        if (source[i] && String(source[i].value) === String(value)) {
          rows.push({ item: source[i], index: i })
        }
      }
      return rows
    },
    expireTimeOption() {
      const rangeStart = this.date && this.date[0]
      const rangeEnd = this.date && this.date[1]
      return {
        disabledDate(date) {
          if (!rangeStart || !rangeEnd) return false
          const normalize = (d) => new Date(d).setHours(0, 0, 0, 0)
          const time = normalize(date)
          const startTime = normalize(rangeStart.replace(/-/g, '/'))
          const endTime = normalize(rangeEnd.replace(/-/g, '/'))
          return time < startTime || time > endTime
        }
      }
    }
  },
  watch: {
    date: {
      handler() {
        this.syncAdvertiserDateByConsumption()
      },
      deep: true
    }
  },
  created() {
    console.log(this.drawerItem)
    window.aaa = this
    this._virtualScrollRaf = {}
    this.myGetchannelplatform() // 获取平台
    this.init()
  },
  mounted() {},
  beforeDestroy() {
    const rafMap = this._virtualScrollRaf || {}
    Object.keys(rafMap).forEach((key) => {
      if (rafMap[key]) cancelAnimationFrame(rafMap[key])
    })
  },
  methods: {
    buildUniqueAdvertiserRows(list) {
      const seen = new Set()
      const rows = []
      const source = list || []
      for (let i = 0; i < source.length; i++) {
        const item = source[i]
        if (!item) continue
        const valueKey = typeof item.value + ':' + item.value
        if (seen.has(valueKey)) continue
        seen.add(valueKey)
        rows.push({
          item,
          index: i,
          key: valueKey + '_' + i
        })
      }
      return rows
    },
    buildVirtualView(rows, scrollTop) {
      const itemHeight = this.virtualTagItemHeight
      const viewport = this.virtualTagViewport
      const buffer = 8
      const total = rows.length
      const maxScroll = Math.max(0, total * itemHeight - viewport)
      const top = Math.min(Math.max(scrollTop || 0, 0), maxScroll)
      const start = Math.max(0, Math.floor(top / itemHeight) - buffer)
      const count = Math.ceil(viewport / itemHeight) + buffer * 2
      const end = Math.min(total, start + count)
      const items = []
      for (let i = start; i < end; i++) {
        items.push({
          item: rows[i].item,
          index: rows[i].index,
          key: rows[i].key,
          top: i * itemHeight
        })
      }
      return {
        totalHeight: total * itemHeight,
        items
      }
    },
    onVirtualScroll(refName, stateKey) {
      const rafMap = this._virtualScrollRaf || (this._virtualScrollRaf = {})
      if (rafMap[refName]) return
      rafMap[refName] = requestAnimationFrame(() => {
        rafMap[refName] = 0
        const el = this.$refs[refName]
        if (el) this[stateKey] = el.scrollTop
      })
    },
    handleAdvertiserDateChange(item, val) {
      this.$set(item, 'date', this.clampAdvertiserDate(val))
    },
    clampAdvertiserDate(itemDate) {
      const consumptionDate = this.getConsumptionDate()
      if (!consumptionDate.length) {
        return itemDate
      }
      const [rangeStart, rangeEnd] = consumptionDate
      if (!itemDate || itemDate.length !== 2 || !itemDate[0] || !itemDate[1]) {
        return [...consumptionDate]
      }
      let start = itemDate[0]
      let end = itemDate[1]
      if (start < rangeStart) {
        start = rangeStart
      }
      if (end > rangeEnd) {
        end = rangeEnd
      }
      if (start > end) {
        return [...consumptionDate]
      }
      return [start, end]
    },
    getConsumptionDate() {
      return this.date && this.date.length === 2 ? [...this.date] : []
    },
    syncAdvertiserDateByConsumption() {
      const consumptionDate = this.getConsumptionDate()
      if (!consumptionDate.length) return
      const syncListDates = (list) => {
        if (!list || !list.length) return
        list.forEach((item, index) => {
          if (
            !item.date ||
            item.date[0] !== consumptionDate[0] ||
            item.date[1] !== consumptionDate[1]
          ) {
            this.$set(list[index], 'date', [...consumptionDate])
          }
        })
      }
      syncListDates(this.advertiserObj)
      syncListDates(this.advertiserObj1)
      if (this.dialogDate) {
        syncListDates(this.advertiserSecondary)
        syncListDates(this.advertiserSecondary1)
      }
    },
    handleConsumptionDateChange() {
      this.syncAdvertiserDateByConsumption()
    },
    subimt() {
      let text = ''
      let blo = false
      if (this.ADtype === 'adq') {
        this.advertiserSecondary.forEach((v, i) => {
          if (v.date.length === 0) {
            blo = true
            text = `第${i + 1}条时间为空`
          }
        })
        if (blo) {
          return this.$message(text)
        }
        this.advertiserObj = JSON.parse(
          JSON.stringify(this.advertiserSecondary)
        ).map((item) => ({
          ...item,
          date: this.clampAdvertiserDate(item.date)
        }))
        this.advertiserValue = this.advertiserObj.map((v) => v.value)
        this.advertiserValue = [...new Set(this.advertiserValue)]
      } else {
        this.advertiserObj1 = JSON.parse(
          JSON.stringify(this.advertiserSecondary1)
        ).map((item) => ({
          ...item,
          date: this.clampAdvertiserDate(item.date)
        }))
        this.advertiserValue1 = this.advertiserObj1.map((v) => v.value)
        this.advertiserValue1 = [...new Set(this.advertiserValue1)]
      }
      this.$message({
        message: '时间更改成功',
        type: 'success'
      })
      this.dialogDate = false
    },
    deleteitem(index, item) {
      if (this.ADtype === 'adq') {
        this.advertiserSecondary.splice(index, 1)
        this.advertiserValue.splice(this.advertiserValue.indexOf(item.value), 1)
      } else {
        this.advertiserSecondary1.splice(index, 1)
        this.advertiserValue1.splice(
          this.advertiserValue1.indexOf(item.value),
          1
        )
      }
    },
    advertiserObjtag(index, type, item) {
      this.index = index
      this.dialogDate = true
      this.ADtype = type
      this.aditem = item
      if (this.ADtype === 'adq') {
        this.advertiserSecondary = JSON.parse(
          JSON.stringify(this.advertiserObj)
        )
      } else {
        this.advertiserSecondary1 = JSON.parse(
          JSON.stringify(this.advertiserObj1)
        )
      }
      console.log(111, this.advertiserSecondary)
    },
    copy() {
      const defaultDate = this.getConsumptionDate()
      if (this.ADtype === 'adq') {
        this.advertiserSecondary.push({
          value: this.aditem.value,
          date: defaultDate,
          label: this.aditem.label
        })
      } else {
        this.advertiserSecondary1.push({
          value: this.aditem.value,
          date: defaultDate,
          label: this.aditem.label
        })
      }
      console.log(1)
      console.log('this.query:', this.advertiserObj, this.advertiserObj1)
    },
    // 选中哪一项
    handleSelect(item) {
      switch (this.current) {
        case '主渠道号':
          this.parameter.master_appid = item
          break
        case '副渠道号': {
          const code = item.address
          const masterCode =
            this.parameter.master_appid && this.parameter.master_appid.address
          const isMaster = String(masterCode) === String(code)
          if (
            code &&
            !isMaster &&
            this.officialValue.every((item) => String(item) !== String(code))
          ) {
            this.officialValue.push(code)
            this.officialObj.push({
              value: code,
              label: item.value
            })
          }
          this.$nextTick(() => {
            this.subChannelName = null
          })
          break
        }
        case '投放组':
          this.parameter.release_group_id = item
          break
        case '投手':
          this.parameter.pitcher_id = item
          break
        case '书名':
          this.parameter.alias_book_id = item
          break
        case '书籍归属':
          this.parameter.book_id = item
          break
        case '投放位置':
          this.parameter.position_id = item
          break
      }
    },
    // 搜索
    async querySearchAsync(queryString, cb) {
      let currentFunc = null
      const obj = {
        主渠道号: 'channel_code',
        副渠道号: 'channel_code',
        投放组: 'release_group_name',
        投手: 'user_name',
        书籍归属: 'book_name',
        书名: 'novel_name',
        投放位置: 'position_name'
      }
      const isChannelSearch =
        this.current === '主渠道号' ||
        this.current === '副渠道号' ||
        this.current === '从渠道号'

      switch (this.current) {
        case '主渠道号':
        case '副渠道号':
        case '从渠道号':
          currentFunc = getTheListOfOfficialAccountNovelSite
          break
        case '投放组':
          currentFunc = getReleaseGroupListNovel
          break
        case '投手':
          currentFunc = getListOfPitchersInTheLaunchGroupNovel
          break
        case '书名':
          currentFunc = getTitleListNovel
          break
        case '书籍归属':
          currentFunc = getBookOwnershipListNovel
          break
        case '投放位置':
          currentFunc = dropLocationListNovel
          break
      }
      if (!currentFunc) {
        return
      }
      if (
        (this.current === '投手' && !this.parameter.release_group_id) ||
        (this.current === '书名' && !this.parameter.book_id) ||
        (this.current === '从渠道号' && !this.parameter.master_appid)
      ) {
        const obj1 = {
          投手: '请先选投放组，才能选投手',
          书名: '请先选择书籍归属，才能选书名',
          从渠道号: '请先选择主渠道号，才能选从渠道号'
        }
        this.$message({
          message: obj1[this.current],
          type: 'warning'
        })
        cb()
        return
      }
      const data = await currentFunc({
        name: !isChannelSearch ? queryString : null,
        channel_name: isChannelSearch ? queryString : null,
        group_id:
          this.current === '投手'
            ? this.parameter.release_group_id.address
            : null,
        book_belong_id: this.parameter.book_id
          ? this.parameter.book_id.address
          : null
      })
      cb(
        data.data.list.map((item) => {
          return {
            value:
              this.current === '书名'
                ? item['novel_name'] +
                  (item['platform'] ? '(' + item['platform'] + ')' : '')
                : isChannelSearch
                  ? `${item.channel_name}(${item.platform_str})`
                  : item[obj[this.current]],
            address: isChannelSearch ? item[obj[this.current]] : item.id
          }
        })
      )
    },
    // 请求平台
    async myGetchannelplatform() {
      const data = await getPlatform({ type: 1 })
      this.platformSelectList = data.data.list
    },
    // 请求初始书名
    async getTitleList() {
      const data = await getTitleListNovel({
        book_alias_id: this.drawerItem.alias_book_id,
        // page: 1,
        // pageSize: 20,
        book_belong_id: this.drawerItem.book_id
      })
      // 书名
      this.parameterNames.alias_book_id_name =
        data.data.list[0] &&
        data.data.list[0].novel_name &&
        data.data.list[0].novel_name +
          (data.data.list[0].platform
            ? '(' + data.data.list[0].platform + ')'
            : '')
      this.parameter.alias_book_id = this.parameterNames.alias_book_id_name && {
        value: this.parameterNames.alias_book_id_name,
        address: this.drawerItem.alias_book_id
      }
    },
    // 选择渠道号
    change(items) {
      if (!items.length) {
        this.officialObj = []
        return
      }
      for (let i = 0; i < items.length; i++) {
        const im = items[i]
        const index = this.officialObj.findIndex((itemm) => itemm.value === im)
        if (index < 0) {
          this.officialObj.push({
            value: im,
            label:
              this.fromOfficialAccount[
                this.fromOfficialAccount.findIndex(
                  (itemm) => itemm.value === im
                )
              ].label
          })
        } else {
          this.officialObj = this.officialObj.filter((imm) => {
            return !(items.indexOf(imm.value) < 0)
          })
        }
      }
    },

    // 删除渠道号
    deleteOfficialAccount(item) {
      this.officialObj.splice(
        this.officialObj.findIndex((im) => im.value === item.value),
        1
      )
      this.officialValue.splice(this.officialValue.indexOf(item.value), 1)
    },
    // 选择广告主
    change1(item) {
      for (let i = 0; i < this.advertiserValue.length; i++) {
        const im = this.advertiserValue[i]
        const index = this.advertiserObj.findIndex(
          (itemm) => itemm.value === im
        )
        index < 0 &&
          this.advertiserObj.push({
            value: im,
            date: this.date,
            label:
              this.fromAdvertiser[
                this.fromAdvertiser.findIndex((itemm) => itemm.value === im)
              ].label
          })
      }
      this.advertiserObj = this.advertiserObj.filter((imm) => {
        return !(item.indexOf(imm.value) < 0)
      })
    },
    // 选择巨量
    change2(item) {
      console.log(this.advertiserValue1)
      for (let i = 0; i < this.advertiserValue1.length; i++) {
        const im = this.advertiserValue1[i]
        const index = this.advertiserObj1.findIndex(
          (itemm) => itemm.value === im
        )
        console.log(
          this.fromAdvertiser1.findIndex((itemm) => itemm.value === im)
        )
        index < 0 &&
          this.advertiserObj1.push({
            value: im,
            date: this.date,
            label:
              this.fromAdvertiser1[
                this.fromAdvertiser1.findIndex((itemm) => itemm.value === im)
              ].label
          })
      }
      this.advertiserObj1 = this.advertiserObj1.filter((imm) => {
        return !(item.indexOf(imm.value) < 0)
      })
    },

    // 删除广告主
    deleteOfficialAccount1(item, index) {
      console.log('item, index:', item, index)
      if (index === 1) {
        this.advertiserObj.splice(
          this.advertiserObj.findIndex((im) => im.value === item.value),
          1
        )
        this.advertiserValue.splice(this.advertiserValue.indexOf(item.value), 1)
      } else {
        this.advertiserObj1.splice(
          this.advertiserObj1.findIndex((im) => im.value === item.value),
          1
        )
        this.advertiserValue1.splice(
          this.advertiserValue1.indexOf(item.value),
          1
        )
      }
    },

    // 确定
    determine() {
      console.log(1111)
      if (this.judgmentParameters()) {
        const parameter = this.assemblyParameters()
        console.log(1111, parameter)

        this.$emit('determine', parameter)
      }
    },

    // 判断参数
    judgmentParameters() {
      let text = null
      if (
        !this.parameter.master_appid ||
        this.parameter.master_appid.value !==
          this.parameterNames.master_appid_name
      ) {
        text = '请选择主渠道号'
      } else if (
        !this.parameter.release_group_id ||
        this.parameter.release_group_id.value !==
          this.parameterNames.release_group_id_name
      ) {
        text = '请选择投放组'
      } else if (
        !this.parameter.pitcher_id ||
        this.parameter.pitcher_id.value !== this.parameterNames.pitcher_id_name
      ) {
        text = '请选择投手'
      } else if (
        !this.parameter.book_id ||
        this.parameter.book_id.value !== this.parameterNames.book_id_name
      ) {
        text = '请选择书籍归属'
      } else if (
        !this.parameter.alias_book_id ||
        this.parameter.alias_book_id.value !==
          this.parameterNames.alias_book_id_name
      ) {
        text = '请选择书名'
      } else if (
        !this.parameter.position_id ||
        this.parameter.position_id.value !==
          this.parameterNames.position_id_name
      ) {
        text = '请选择投放位置'
      } else if (
        !this.advertiserValue.length &&
        !this.advertiserValue1.length
      ) {
        text = '请选择ADQ广告主或者巨量广告'
      } else if (!this.parameter.platform_id) {
        text = '请选择平台'
      } else if (!this.date || !this.date.length) {
        text = '请选择日期'
      } else if (!this.dates || !this.dates.length) {
        text = '请选择新用户充值时间'
      }

      text &&
        this.$message({
          message: text,
          type: 'warning'
        })

      return !text
    },

    // 组装参数
    assemblyParameters() {
      const adq_advertiser_time_relation = this.advertiserObj.map((v) => {
        const result = {
          account_id: v.value,
          start_date: v.date[0] || this.date[0],
          end_date: v.date[1] || this.date[1]
        }
        if (v.id) {
          result.id = v.id
        }
        return result
      })

      const ocean_advertiser_time_relation = this.advertiserObj1.map((v) => {
        const result = {
          account_id: v.value,
          start_date: v.date[0] || this.date[0],
          end_date: v.date[1] || this.date[1]
        }
        if (v.id) {
          result.id = v.id
        }
        return result
      })
      console.log(
        ocean_advertiser_time_relation,
        adq_advertiser_time_relation,
        this.advertiserObj1
      )
      const obj = {
        begin_time: this.date[0],
        end_time: this.date[1],
        recharge_begin: this.dates[0],
        recharge_end: this.dates[1],
        master_channel_code: this.parameter.master_appid.address,
        channel_codes: this.officialValue.filter(
          (code) =>
            String(code) !== String(this.parameter.master_appid.address)
        ),
        release_group_id: this.parameter.release_group_id.address,
        pitcher_id: this.parameter.pitcher_id.address,
        alias_book_id: this.parameter.alias_book_id.address,
        book_id: this.parameter.book_id.address,
        position_id: this.parameter.position_id.address,
        adq_advertiser_ids: this.advertiserValue,
        ocean_advertiser_ids: this.advertiserValue1,
        platform_id: this.parameter.platform_id,
        ocean_advertiser_time_relation,
        adq_advertiser_time_relation
      }

      return obj
    },

    // 初始化
    init() {
      if (this.drawerItem && this.drawerItem.id) {
        this.getTitleList()
      } else {
        // 书名
        this.parameterNames.alias_book_id_name = this.drawerItem.novel_name
        this.parameter.alias_book_id = this.parameterNames
          .alias_book_id_name && {
          value: this.parameterNames.alias_book_id_name,
          address: this.drawerItem.alias_book_id
        }
      }
      if (this.drawerItem.begin_time && this.drawerItem.end_time) {
        // 时间
        this.date[0] = this.drawerItem.begin_time
        this.date[1] = this.drawerItem.end_time
      }
      if (this.drawerItem.recharge_begin && this.drawerItem.recharge_end) {
        // 新用户充值时间
        this.dates[0] = this.drawerItem.recharge_begin
        this.dates[1] = this.drawerItem.recharge_end
      }
      // 主渠道号 / 副渠道号：按渠道码区分，名称通过接口回填，避免和 channel_names 下标对错
      const toList = (val) => {
        if (!val) return []
        return Array.isArray(val) ? [...val] : Object.values(val)
      }
      const masterCode = this.drawerItem.master_channel_code
      const codes = toList(this.drawerItem.channel_codes)
      const subCodes = codes.filter(
        (code) => String(code) !== String(masterCode)
      )
      this.parameterNames.master_appid_name = null
      this.parameter.master_appid = masterCode
        ? {
          value: null,
          address: masterCode
        }
        : null
      this.subChannelName = null
      this.officialValue = subCodes
      this.fromOfficialAccount = subCodes.map((code) => ({
        value: code,
        label: code
      }))
      this.officialObj = subCodes.map((code) => ({
        value: code,
        label: code
      }))
      this.hydrateChannelDisplay()
      // 投放组
      this.parameterNames.release_group_id_name =
        this.drawerItem.release_group_name
      this.parameter.release_group_id = this.parameterNames
        .release_group_id_name && {
        value: this.drawerItem.release_group_name,
        address: this.drawerItem.release_group_id
      }

      // 投手
      this.parameterNames.pitcher_id_name = this.drawerItem.pitcher_name
      this.parameter.pitcher_id = this.parameterNames.pitcher_id_name && {
        value: this.drawerItem.pitcher_name,
        address: this.drawerItem.pitcher_id
      }
      // 书籍归属
      this.parameterNames.book_id_name = this.drawerItem.belong_name
      this.parameter.book_id = this.parameterNames.book_id_name && {
        value: this.drawerItem.belong_name,
        address: this.drawerItem.book_id
      }
      // 投放位置
      this.parameterNames.position_id_name = this.drawerItem.position_name
      this.parameter.position_id = this.parameterNames.position_id_name && {
        value: this.drawerItem.position_name,
        address: this.drawerItem.position_id
      }
      // 广告主
      this.advertiserValue =
        this.drawerItem.adq_advertiser_ids &&
        this.drawerItem.adq_advertiser_ids.length
          ? [...this.drawerItem.adq_advertiser_ids]
          : []
      this.fromAdvertiser = this.advertiserValue.length
        ? this.drawerItem.adq_advertiser.map((item, index) => {
          return {
            value: item.account_id,
            label: `${
              item.account_name && item.account_id
                ? item.account_name + '--'
                : item.account_name
            }${
              item.account_id && item.agent_name
                ? item.account_id + '--'
                : item.account_id
            }${item.agent_name || ''}`
          }
        })
        : []
      this.advertiserObj = this.advertiserValue.length
        ? this.drawerItem.adq_advertiser.flatMap((item, index) => {
          let result = {}
          if (item.time_relations.length === 0) {
            result = {
              value: item.account_id,
              date: [],
              label: `${
                item.account_name && item.account_id
                  ? item.account_name + '--'
                  : item.account_name
              }${
                item.account_id && item.agent_name
                  ? item.account_id + '--'
                  : item.account_id
              }${item.agent_name || ''}`
            }
          } else {
            result = item.time_relations.flatMap((times) => {
              var date = [times.start_date, times.end_date]
              return {
                value: item.account_id,
                date,
                id: times.id,
                label: `${
                  item.account_name && item.account_id
                    ? item.account_name + '--'
                    : item.account_name
                }${
                  item.account_id && item.agent_name
                    ? item.account_id + '--'
                    : item.account_id
                }${item.agent_name || ''}`
              }
            })
          }
          return result
        })
        : []
      // 巨量广告
      this.advertiserValue1 =
        this.drawerItem.ocean_advertiser_ids &&
        this.drawerItem.ocean_advertiser_ids.length
          ? [...this.drawerItem.ocean_advertiser_ids]
          : []
      this.fromAdvertiser1 = this.advertiserValue1.length
        ? this.drawerItem.ocean_advertiser.map((item, index) => {
          return {
            value: item.account_id,
            label: `${
              item.account_name && item.account_id
                ? item.account_name + '--'
                : item.account_name
            }${
              item.account_id && item.agent_name
                ? item.account_id + '--'
                : item.account_id
            }${item.agent_name || ''}`
          }
        })
        : []
      this.advertiserObj1 = this.advertiserValue1.length
        ? this.drawerItem.ocean_advertiser.flatMap((item, index) => {
          let result = {}
          if (item.time_relations.length === 0) {
            result = {
              value: item.account_id,
              date: [],
              label: `${
                item.account_name && item.account_id
                  ? item.account_name + '--'
                  : item.account_name
              }${
                item.account_id && item.agent_name
                  ? item.account_id + '--'
                  : item.account_id
              }${item.agent_name || ''}`
            }
          } else {
            result = item.time_relations.flatMap((times) => {
              var date = [times.start_date, times.end_date]
              return {
                value: item.account_id,
                date,
                id: times.id,
                label: `${
                  item.account_name && item.account_id
                    ? item.account_name + '--'
                    : item.account_name
                }${
                  item.account_id && item.agent_name
                    ? item.account_id + '--'
                    : item.account_id
                }${item.agent_name || ''}`
              }
            })
          }
          return result
        })
        : []
      console.log(
        this.drawerItem.adq_advertiser_time_relation,
        '===0',
        this.advertiserObj,
        this.advertiserObj1
      )

      // 平台
      this.parameter.platform_id = this.drawerItem.platform_id
    },
    formatChannelLabel(item) {
      if (!item) return ''
      return item.platform_str
        ? `${item.channel_name}(${item.platform_str})`
        : item.channel_name || item.channel_code
    },
    async hydrateChannelDisplay() {
      const masterCode =
        this.parameter.master_appid && this.parameter.master_appid.address
      const codes = [masterCode, ...this.officialValue].filter(Boolean)
      if (!codes.length) return
      const uniqueCodes = codes.filter(
        (code, index) =>
          codes.findIndex((item) => String(item) === String(code)) === index
      )
      const nameMap = {}
      const fillFromList = (list) => {
        list.forEach((item) => {
          if (item && item.channel_code) {
            nameMap[String(item.channel_code)] = this.formatChannelLabel(item)
          }
        })
      }
      const allData = await getTheListOfOfficialAccountNovelSite()
      fillFromList((allData.data && allData.data.list) || [])
      const missing = uniqueCodes.filter((code) => !nameMap[String(code)])
      if (missing.length) {
        const extra = await Promise.all(
          missing.map((code) =>
            getTheListOfOfficialAccountNovelSite({ channel_name: code })
          )
        )
        extra.forEach((res) => {
          fillFromList((res.data && res.data.list) || [])
        })
      }
      if (masterCode) {
        const masterName = nameMap[String(masterCode)] || String(masterCode)
        this.parameterNames.master_appid_name = masterName
        this.parameter.master_appid = {
          value: masterName,
          address: masterCode
        }
      }
      this.officialObj = this.officialValue.map((code) => ({
        value: code,
        label: nameMap[String(code)] || String(code)
      }))
      this.fromOfficialAccount = this.officialObj.map((item) => ({ ...item }))
    },
    handleParams1(value, index) {
      if (index === 1) {
        const str =
          /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、 ]/gim
        this.multipleSub1 = value.replace(str, ',')

        const str1 = /(,){1,}/gim
        this.multipleSub1 = this.multipleSub1.replace(str1, ',')
      } else {
        const str =
          /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、 ]/gim
        this.multipleSub2 = value.replace(str, ',')

        const str1 = /(,){1,}/gim
        this.multipleSub2 = this.multipleSub2.replace(str1, ',')
      }
    },
    // 选中多个副渠道号
    async multipleSubOfficialAccount() {
      if (!this.multipleSub) {
        this.$message({
          message: '必须输入 id 或 名字',
          type: 'warning'
        })
        return
      }

      // 获取渠道号
      const data = await getTheListOfOfficialAccountNovelSite({
        channel_name: this.multipleSub
      })

      // 判断是否为空
      if (!data.data.list.length) {
        this.$message({
          message: '筛选为0个，没法选中',
          type: 'warning'
        })
      }

      // 将获取到的渠道号变更下字段名
      let news = data.data.list.map((item) => {
        return {
          value: item.channel_code,
          label: item.channel_code
        }
      })

      this.fromOfficialAccount = news

      for (let i = 0; i < news.length; i++) {
        this.officialValue.indexOf(news[i].value) < 0 &&
          this.officialValue.push(news[i].value)
      }

      news = news.map((im) => im.value)

      for (let i = 0; i < this.officialValue.length; i++) {
        news.indexOf(this.officialValue[i]) < 0 &&
          news.push(this.officialValue[i])
      }

      this.change(news)

      data.data.list.length &&
        this.judgeThatOneIsNotSelected(
          this.multipleSub,
          data.data.list,
          'channel_code'
        )

      this.multipleSub = null
    },

    handleParams(value) {
      const str =
        /[`~!@#$%^&*()_\+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\+={}|《》？：“”【】、；‘'，。、 ]/gim
      this.multipleSub = value.replace(str, ',')

      const str1 = /(,){1,}/gim
      this.multipleSub = this.multipleSub.replace(str1, ',')
    },
    // 选中多个广告主或者巨量广告
    async multipleSubOfficialAccount1(type) {
      if (type === 1) {
        if (!this.multipleSub1) {
          this.$message({
            message: '必须输入ADQ广告主 id 或 名字',
            type: 'warning'
          })
          return
        }
      } else {
        if (!this.multipleSub2) {
          this.$message({
            message: '必须输入巨量广告 id 或 名字',
            type: 'warning'
          })
          return
        }
      }
      const data = await getAdvertiserNovel({
        name: type === 1 ? this.multipleSub1 : this.multipleSub2,
        type: type
      })
      if (!data.data.list.length) {
        this.$message({
          message: '筛选为0个，没法选中',
          type: 'warning'
        })
      }
      let news = data.data.list.map((item) => {
        return {
          value: item.account_id,
          label: `${
            item.account_name && item.account_id
              ? item.account_name + '--'
              : item.account_name
          }${
            item.account_id && item.agent_name
              ? item.account_id + '--'
              : item.account_id
          }${item.agent_name || ''}`
        }
      })
      if (type === 1) {
        // 广告主模块
        this.fromAdvertiser = news
        for (let i = 0; i < news.length; i++) {
          this.advertiserValue.indexOf(news[i].value) < 0 &&
            this.advertiserValue.push(news[i].value)
        }
        news = news.map((im) => im.value)
        for (let i = 0; i < this.advertiserValue.length; i++) {
          news.indexOf(this.advertiserValue[i]) < 0 &&
            news.push(this.advertiserValue[i])
        }
        this.change1(news)
        data.data.list.length &&
          this.judgeThatOneIsNotSelected(
            this.multipleSub1,
            data.data.list,
            'account_id'
          )
        this.multipleSub1 = null
      } else {
        // 巨量广告模块
        this.fromAdvertiser1 = news
        for (let i = 0; i < news.length; i++) {
          this.advertiserValue1.indexOf(news[i].value) < 0 &&
            this.advertiserValue1.push(news[i].value)
        }
        news = news.map((im) => im.value)
        for (let i = 0; i < this.advertiserValue1.length; i++) {
          news.indexOf(this.advertiserValue1[i]) < 0 &&
            news.push(this.advertiserValue1[i])
        }
        this.change2(news)
        data.data.list.length &&
          this.judgeThatOneIsNotSelected(
            this.multipleSub2,
            data.data.list,
            'account_id'
          )
        this.multipleSub2 = null
      }
    },
    // 创建渲染回填时想要的结构数据
    createTheDesiredStructure(isL) {
      console.log('创建渲染回填时想要的结构数据')
      const obj = !isL
        ? {
          begin_time: this.date && this.date[0], // 开始时间
          end_time: this.date && this.date[1], // 结束时间
          recharge_begin: this.dates && this.dates[0], // 新用户充值开始时间
          recharge_end: this.dates && this.dates[1], // 新用户充值结束时间
          channel_codes: this.officialValue.filter(
            (code) =>
              String(code) !==
              String(
                this.parameter.master_appid &&
                  this.parameter.master_appid.address
              )
          ),
          channel_names: this.officialObj.map((item) => item.label),
          master_channel_code:
              this.parameter.master_appid &&
              this.parameter.master_appid.address, // 主渠道号

          // channel_codes: this.parameter.channel_codes ? [this.parameter.channel_codes, ...this.officialValue] : [...this.officialValue], // 选中的公众号的id

          // 投放组
          release_group_name: this.parameterNames.release_group_id_name,
          release_group_id:
              this.parameter.release_group_id &&
              this.parameter.release_group_id.address,

          // 投手
          pitcher_id:
              this.parameter.pitcher_id && this.parameter.pitcher_id.address,
          pitcher_name: this.parameterNames.pitcher_id_name,

          // 书籍归属
          belong_name: this.parameterNames.book_id_name,
          book_id: this.parameter.book_id && this.parameter.book_id.address,

          // 书名
          novel_name: this.parameterNames.alias_book_id_name,
          alias_book_id:
              this.parameter.alias_book_id &&
              this.parameter.alias_book_id.address,

          // 投放位置
          position_name: this.parameterNames.position_id_name,
          position_id:
              this.parameter.position_id && this.parameter.position_id.address,

          // 平台
          platform_id: this.parameter.platform_id,

          // 广告主
          adq_advertiser_ids:
              this.advertiserValue && this.advertiserValue.length
                ? this.advertiserValue
                : [],
          adq_advertiser:
              this.advertiserObj && this.advertiserObj.length
                ? this.advertiserObj.map((item) => {
                  const s = item.label.split('--')
                  return {
                    account_id: item.value,
                    account_name: s[0],
                    time_relations: [
                      { start_date: item.date[0], end_date: item.date[1] }
                    ],
                    agent_name: s[s.length - 1]
                  }
                })
                : [],
          // 巨量广告
          ocean_advertiser_ids:
              this.advertiserValue1 && this.advertiserValue1.length
                ? this.advertiserValue1
                : [],
          ocean_advertiser:
              this.advertiserObj1 && this.advertiserObj1.length
                ? this.advertiserObj1.map((item) => {
                  const s = item.label.split('--')
                  return {
                    account_id: item.value,
                    account_name: s[0],
                    time_relations: [
                      { start_date: item.date[0], end_date: item.date[1] }
                    ],
                    agent_name: s[s.length - 1]
                  }
                })
                : []
        }
        : {}
      console.log(this.advertiserObj, '===========')
      return obj
    },

    // 判断那个没选中
    judgeThatOneIsNotSelected(texts, arr, idName) {
      const testsr = texts.split(',')
      const unchecked = []
      testsr.forEach((text) => {
        let bool = true
        for (let i = 0; i < arr.length; i++) {
          if (
            String(arr[i][idName]) === String(text) ||
            String(arr[i].account_name) === String(text)
          ) {
            bool = false
            break
          }
        }
        bool && unchecked.push(text)
      })

      unchecked.length &&
        this.$message({
          message: unchecked.join() + '  没被选中',
          type: 'warning'
        })
    }
  }
}
</script>

<style scoped>
.item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.item .title {
  display: inline-block;
  width: 110px;
}
.hide-close-button ::v-deep .el-range__close-icon {
  display: none;
}
.checkBox {
  margin-bottom: 26px;
}

.checkBox_title {
}

.checkBox_content {
}

.content_item {
}
.virtual-tag-scroller {
  overflow-y: auto;
}
.virtual-tag-phantom {
  position: relative;
  width: 100%;
}
.virtual-tag-row {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  overflow: hidden;
}
.virtual-tag-row ::v-deep .virtual-tag.el-tag {
  display: inline-flex;
  align-items: center;
  max-width: calc(100% - 10px);
  margin: 5px;
  box-sizing: border-box;
  vertical-align: middle;
}
.virtual-tag-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
